<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1280px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px; padding-left:10px;">
            <el-button type="text">
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.groupName"
              placeholder="成员所在群名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.nickname"
              placeholder="成员昵称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.phone"
              placeholder="手机号码"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.certificateNo"
              placeholder="专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table2
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @matchQuestionnaireUser="handleMatchQuestionnaireUser(arguments)"
        />
      </div>
    </div>

    <!-- 匹配问卷用户 -->
    <match-questionnaire-dialog
      :data-id="id"
      :questionnaire-user-ids="questionnaireUserIds"
      :dialog-visible.sync="dialogMatchQuestionnaireUserVisible"
      @reloadData="reloadMasterData()"
    />
  </el-dialog>
</template>

<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin2 from '@/mixin/dialogTableCustomMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 微信群成员匹配问卷用户
import matchQuestionnaireDialog from './matchQuestionnaireDialog';
// API
import { loadToMatchContactListDataApi } from '@/api/v2/weChatContact';

export default {
  name: 'TodoMatchQuestionnaireUserList',
  components: { CustomTable2, matchQuestionnaireDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin2],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'todo_match_questionnaire_user_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'matchQuestionnaireUser',
            label: '匹配问卷用户',
            method: 'matchQuestionnaireUser'
          },
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 30,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          groupNames: '',
          nickname: '',
          phone: '',
          certificateNo: '',
        }
      },
      isPaging: true,
      id: null,
      questionnaireUserIds: null,
      dialogMatchQuestionnaireUserVisible: false,
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this
        _this.tableList.initTableColumn = [
          { prop: 'rowNumber', label: '序号', width: 80 },
          { prop: 'userName', label: '成员微信号', filterColumn: 'twcc.user_name', width: 150 },
          { prop: 'nickname', label: '成员昵称', filterColumn: 'twcc.nickname', width: 150 },
          { prop: 'groupNames', label: '所在微信群', filterColumn: "ifnull(crg.group_names, '')", width: 200 },
          { prop: 'provinceNames', label: '所属省区', filterColumn: "ifnull(crg.province_names, '')", width: 130 },
          { prop: 'nicknameNum', label: '待匹配问卷用户数', filterColumn: 'count(tsqu.nickname)', width: 160 },
          { prop: 'appUserName', label: '睿零售用户姓名', filterColumn: "ifnull(tau.name, '')", width: 140 },
          { prop: 'appUserPhone', label: '睿零售用户电话', filterColumn: "ifnull(tau.phone, '')", width: 140 },
          { prop: 'appUserStoreName', label: '睿零售门店名称', filterColumn: "ifnull(tau.store_name, '')", width: 150 },
          { prop: 'appUserCertificateNo', label: '睿零售专卖证号', filterColumn: "ifnull(tau.certificate_no, '')", width: 150 },
        ]
        _this.tableList.tableColumns = _this.tableList.initTableColumn
        _this.searchData(_this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData() {
      let _this = this;
      loadToMatchContactListDataApi(_this.tableList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(_this.tableList, data.list || []);
        _this.tableList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 关闭弹框
    modalClose() {
      this.$emit('update:dialogVisible', false)
    },
    // 刷新列表
    reloadMasterData() {
      let _this = this;
      _this.$emit('reloadData')
      _this.loadTableData(_this.tableList)
    },
    // 匹配问卷用户
    handleMatchQuestionnaireUser(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要匹配问卷用户的微信群成员', type: 'warning' })
        return
      }
      _this.id = args[0].id;
      _this.questionnaireUserIds = args[0].questionnaireUserIds;
      _this.dialogMatchQuestionnaireUserVisible = !_this.dialogMatchQuestionnaireUserVisible;
    },
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
